<h1 mat-dialog-title>Schedule Entry</h1>
<div mat-dialog-content>

  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Name</mat-label>
    <input matInput placeholder="Entry name" [(ngModel)]="item.name" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Start date & time</mat-label>
    <input matInput required type="datetime-local" [formControl]="startControl">
    <mat-hint>{{relativeStart}}</mat-hint>
  </mat-form-field>
  <div class="unix-row"><label>Unix seconds</label><input type="number" [(ngModel)]="unixStart" (change)="setFromUnix('start')"></div>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>End date & time</mat-label>
    <input matInput required type="datetime-local" [formControl]="endControl">
    <mat-hint>{{relativeEnd}}</mat-hint>
  </mat-form-field>
  <div class="unix-row"><label>Unix seconds</label><input type="number" [(ngModel)]="unixEnd" (change)="setFromUnix('end')"></div>


  <mat-form-field>
    <mat-label>Type</mat-label>
    <mat-select [(value)]="item.type">
      <mat-option *ngFor="let type of types" [value]="type">
        {{type}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Location</mat-label>
    <mat-select [(value)]="item.location">
      <mat-option *ngFor="let loc of locations" [value]="loc">
        {{loc}}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <br><br>
  <mat-checkbox [checked]="delayed" (change)="delayed = $event.checked"></mat-checkbox> Delayed
  <mat-checkbox [checked]="item.cancelled" (change)="item.cancelled = $event.checked"></mat-checkbox> Cancelled


  <br>
  <h3>Quick Actions</h3>
  <span>
    <button mat-raised-button (click)="startNow()">Start Now</button>
    <button mat-stroked-button (click)="pushBack(-5)">−5 mins</button>
    <button mat-stroked-button (click)="pushBack(5)">+5 mins</button>
  </span>
</div>

<div mat-dialog-actions>
  <button mat-button color="warn" (click)="remove()" *ngIf="item.id !== 0">Remove</button>
  <span class="spacer"></span>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!canSave()">Save</button>
</div>
